import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { closeErrorWindow } from "../reducers/uploadFileReducer";
import { useDispatch, connect } from "react-redux";
import { updateStepperState, setAnimationClass } from "../reducers/controlReducer";



const Error = (props) => {
  //const dispatch = useDispatch();
  const onBtnClickHandler = () => {
    props.setAnimation("animate__fadeOut");
    setTimeout(() => {
      props.onClose();
    }, 500);
  };
  return (
    <div className="row">
      <div className={`error-msg text-center animate__animated ${props.className}`}>
        <p>{props.text}</p>
        <button className="x-mark" onClick={() => onBtnClickHandler()}>
          <FontAwesomeIcon icon={faXmark} size="2x" />
        </button>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setAnimation: (animation) => dispatch(setAnimationClass(animation)),
    onClose: () => dispatch(closeErrorWindow()),
  };
};
export default connect(null, mapDispatchToProps)(Error);
